import { Form, FormControlProps } from "react-bootstrap";
import licencePlate from "./assets/licencePlate.svg";

export const LicencePlateField = (props: FormControlProps) => {
  return (
    <div
      className={
        "licence-plate-field-wrapper" + (props.isInvalid ? " is-invalid" : "")
      }
    >
      <Form.Control as="input" {...props} className="licence-plate-field" />
      <img src={licencePlate} alt="licence plate" className="licence-plate" />
    </div>
  );
};
